import request from '@/utils/request';

// 复用 PC 端的接口定义
export interface CustomerLoginParams {
  username_or_phone: string;
  password?: string;
  verification_code?: string;
  login_type: 'password' | 'code';
}

export interface CustomerRegisterParams {
  phone: string;
  verification_code: string;
  password?: string;
  register_source?: string;
  referrer_phone?: string;
}

export interface SendCodeParams {
  phone: string;
}

// API 实现
export function sendCustomerCode(params: SendCodeParams) {
  return request({
    url: '/customer/auth/send-code',
    method: 'POST',
    params
  });
}

export function customerRegister(data: CustomerRegisterParams) {
  return request({
    url: '/customer/auth/register',
    method: 'POST',
    data
  });
}

export function customerLogin(data: CustomerLoginParams) {
  return request({
    url: '/customer/auth/login',
    method: 'POST',
    data
  });
}

export interface CustomerInfo {
    id: number;
    username: string;
    nickname: string;
    phone: string;
    avatar?: string;
    gender?: number;
    email?: string;
    birthday?: string;
    status: number;
    created_at: string;
    referrer_id?: number;
    referrer_phone?: string;
    referrer_nickname?: string;
    ll_status?: string;
    has_referred_others?: boolean;
    [key: string]: any;
}

export function getCustomerInfo() {
  return request({
    url: '/customer/me',
    method: 'GET'
  }) as Promise<CustomerInfo>;
}

export function resetPassword(data: any) {
  return request({
    url: '/customer/auth/reset-password',
    method: 'POST',
    data
  });
}
